<div class="category-page" [attr.data-testing-id]="category().uniqueId">
  <div class="marketing-area">
    @if (category().categoryRef) {
    <ish-content-viewcontext
      viewContextId="viewcontext.include.category.base.top"
      [callParameters]="{ Category: category().categoryRef }"
    />
    }
  </div>
  <div class="row">
    <div class="col-md-3">
      <ish-skip-content-link skipToElementId="nav-breadcrumbs" linkText="category.navigation.skip_content.link.text" />
      <custom-clear-all-filter />
      <custom-now-shopping-navigation />
      <div class="navigation-panel" [ngbCollapse]="isCollapsed">
        <!--  <ish-category-navigation [uniqueId]="category.categoryPath[0]"></ish-category-navigation> -->

        <!-- Filter Navigation component included for dias customization  -->
        <nav [attr.aria-label]="'category.navigation.aria_label' | translate">
          <custom-filter-navigation [showCategoryFilter]="true" />
        </nav>
        <div class="marketing-area">
          @if (category().categoryRef) {
          <ish-content-viewcontext
            viewContextId="viewcontext.include.category.navigation"
            [callParameters]="{ Category: category().categoryRef }"
          />
          }
        </div>
      </div>
      <a class="d-md-none mobile-filter-toggle btn btn-link btn-link-action link-decoration-hover" (click)="toggle()">
        {{ 'search.mobile.filter.trigger' | translate }}
        <fa-icon [icon]="['fas', isCollapsed ? 'angle-down' : 'angle-up']" />
      </a>
    </div>

    <div class="col-md-9">
      <ish-breadcrumb />
      <h1>{{ category().name }}</h1>

      <div class="marketing-area">
        @if (category().categoryRef) {
        <ish-content-viewcontext
          viewContextId="viewcontext.include.category.content.top"
          [callParameters]="{ Category: category().categoryRef }"
        />
        }
      </div>

      <ish-category-list [categories]="category().children" />

      <div class="marketing-area">
        @if (category().categoryRef) {
        <ish-content-viewcontext
          viewContextId="viewcontext.include.category.content.bottom"
          [callParameters]="{ Category: category().categoryRef }"
        />
        }
      </div>
      <ng-container>
        <ish-product-links></ish-product-links>
      </ng-container>
    </div> 
  </div>
  <div class="marketing-area">
    @if (category().categoryRef) {
    <ish-content-viewcontext
      viewContextId="viewcontext.include.category.base.bottom"
      [callParameters]="{ Category: category().categoryRef }"
    />
    }
  </div>
</div>
